import Breadcrumb from "@/components/feature/Breadcrumb";
import { Link } from "react-router-dom";
import NewsCard from "@/components/feature/NewsCard";
import EmptyState from "@/components/base/EmptyState";
import { usePageMeta } from "@/hooks/usePageMeta";
import { getLatestNews, getHotMedia } from "@/utils/media";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function NewsListPage() {
  usePageMeta({
    title: "影视资讯 - 影视动态与影评 - 17C.COM",
    description:
      "17C.COM 影视资讯频道，汇集最新电影电视剧动态、深度影评与行业观察，第一时间掌握影视圈的新鲜事。",
    keywords: "影视资讯,影视动态,影评,剧集动态,行业资讯,17C.COM",
  });

  const news = getLatestNews(8);
  const hot = getHotMedia(6);

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-8 md:px-6 md:py-10">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "影视资讯" }]} />

      <header className="mb-8">
        <h1 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          影视资讯
        </h1>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-500">
          汇集最新影视动态、深度影评与行业观察，带你第一时间了解正在发生的故事。
        </p>
      </header>

      {news.length > 0 ? (
        <>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {news.slice(0, 3).map((item) => (
              <NewsCard key={item.id} item={item} />
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-3">
            <div className="space-y-3 lg:col-span-2">
              {news.slice(3).map((item) => (
                <NewsCard key={item.id} item={item} variant="wide" />
              ))}
            </div>
            <aside>
              <div className="rounded-lg border border-background-200 bg-background-100 p-5">
                <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-fire-line text-accent-500" aria-hidden="true" />
                  热门影视
                </h2>
                <ul className="mt-4 space-y-3">
                  {hot.map((item, index) => (
                    <li key={item.id}>
                      <Link
                        to={`/detail/${item.id}`}
                        className="group flex items-center gap-3"
                      >
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded bg-primary-100 text-xs font-bold text-primary-700">
                          {index + 1}
                        </span>
                        <span className="line-clamp-1 flex-1 text-sm text-foreground-700 transition-colors group-hover:text-primary-600">
                          {item.title}
                        </span>
                        <span className="text-xs text-accent-600">
                          {item.rating.toFixed(1)}
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </aside>
          </div>
        </>
      ) : (
        <EmptyState title="暂无内容，敬请期待" />
      )}

      <section className="mt-12">
        <SectionHeading icon="ri-movie-line" title="值得一看" moreTo="/category" />
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
          {hot.map((item) => (
            <MovieCard key={item.id} item={item} />
          ))}
        </div>
      </section>
    </div>
  );
}